<template>
  <section
    id="cover"
    class="te-bg-design-portfolio-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 500px"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faBook"
        class="fa-fw mr-3 mt-2 hidden h-9 w-8 md:inline-block"
      />
      デザイン実践ポートフォリオコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      制作業務で通用するデザインスキルを身につけよう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        デザイン実践ポートフォリオコースは、さらなるスキル
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >を身につけることができる講座。スクールでは、PhotoshopやXDを使いこなして実務で通用するスキルを身につけることがゴールです。1人では続かない方のためのパーソナルメンターがつくブートキャンプ。メンターは全員、通過率10%の選考を通過した現役Webデザイナーです。専属のパーソナルメンターがマンツーマンでサポート。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>
    <!-- Adobeバッジ -->
    <TeCommonBadgeAdobe />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeAdobe from '~/components/Te/TeCommon/Badge/Adobe/TeCommonBadgeAdobe.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBook, faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faBook,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeAdobe,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-design-portfolio-image {
  background-image: linear-gradient(
    to top,
    rgba(224, 154, 68, .75),
    rgba(224, 154, 68, .75)
  ),
    url('~/assets/images/Te/TeCourse/DesignPortfolio/Cover/design-portfolio.jpg');
}
</style>
